var _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 18,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#221F20",
  className: "close_svg__plus"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 8H0v2h9V8Z",
  className: "close_svg__left"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 8h-9v2h9V8Z",
  className: "close_svg__right"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#221F20",
  d: "m-.03 0 24-.079.007 2-24 .079z",
  className: "close_svg__top"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#221F20",
  d: "m-.003 8 24-.079.006 2-24 .079z",
  className: "close_svg__middle"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2985F",
  d: "m.023 16 24-.079.007 2L.03 18z",
  className: "close_svg__gold"
})));
export default SvgClose;